import { Outlet, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { JugglingScreen, SidebarProvider } from "@motleyhand/design"
import AppSidebar from "../sidebar/AppSidebar"
import { useAuth, useRedirectAfterLogin } from "@/auth"
import { Notifications } from "@/notification"

export default function UserRoute() {
  const { isLoading, isAuthenticated } = useAuth()
  const { setRedirectUrl } = useRedirectAfterLogin()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading) {
      return
    }
    if (!isAuthenticated) {
      setRedirectUrl()
      void navigate({ to: "/auth", replace: true })
    }
  }, [isLoading, isAuthenticated, navigate, setRedirectUrl])

  if (isLoading || !isAuthenticated) {
    return <JugglingScreen />
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <div className="flex h-dvh min-w-0 flex-1 flex-col">
        <Notifications />
        <Outlet />
      </div>
    </SidebarProvider>
  )
}
